import { render } from "./setAvatar.vue?vue&type=template&id=2022ca12&scoped=true"
import script from "./setAvatar.vue?vue&type=script&lang=js"
export * from "./setAvatar.vue?vue&type=script&lang=js"

import "./setAvatar.vue?vue&type=style&index=0&id=2022ca12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2022ca12"]])

export default __exports__